<!-- @veltra/icons generated sha256:8d7f7482e58c826c gen:8 source:src/svg/normal/unlock.svg -->
<script setup lang="ts">
defineOptions({ name: 'Unlock' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M4.5 5v1H3a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 13 6H5.5V5a2.5 2.5 0 0 1 4.95-.499c.055.27.278.499.546.499.276 0 .508-.228.468-.502A3.5 3.5 0 0 0 4.5 5m-1 2h9v6h-9zm3 3c-.275 0-.5.228-.5.496 0 .276.225.504.5.504h3c.275 0 .5-.228.5-.496A.504.504 0 0 0 9.5 10z"
    />
  </svg>
</template>
